module.exports = __webpack_public_path__ + "img/4.e66905e4.jpeg";